import { render } from "./AddVocabulary.vue?vue&type=template&id=548db4d5"
import script from "./AddVocabulary.vue?vue&type=script&lang=js"
export * from "./AddVocabulary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__